import type {
  ThemingProps} from '@chakra-ui/react'
import {
  Box,
  createStylesContext,
  useMultiStyleConfig,
} from '@chakra-ui/react'

import { Container } from '../components/Container'
import { AppSwitcher } from './AppSwitcher'
import { Menu } from './Menu/Menu'
import { MobileMenu } from './Menu/MobileMenu'
import { NewInsuranceLink } from './NewInsuranceLink'

export const Header = ({ variant }: ThemingProps) => {
  const styles = useMultiStyleConfig('Header', { variant })

  const [StylesProvider] = createStylesContext('Component')

  return (
    <>
      <Box __css={styles.header}>
        <StylesProvider value={styles}>
          <Container>
            <Box __css={styles.content} as="nav">
              <Box __css={styles.logo}>
                <AppSwitcher />
              </Box>

              <Menu />
              <NewInsuranceLink />
              <MobileMenu />
            </Box>
          </Container>
        </StylesProvider>
      </Box>
    </>
  )
}
